<template>
   <div>
        <div id="cta" class="feature background background-243499767">
            <div class="feature-margin">
                <div class="form-cta shadow">
                    <form id="form-cadastro-LandingPageInvistaIouu" @submit.prevent="signUp">
                        <div class="row">
                            <div class="col-12">
                                <h1>Invista com alta rentabilidade na IOUU</h1>
                                <p>Cadastre-se gratuitamente e invista sem taxas</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <input type="text" name="firstname" @keyup="validateName()" class="form-control form-control-lg" placeholder="Seu nome" v-model="name" required autofocus>
                            </div>
                            <div class="col-12 col-md-6">
                                <input v-on:focusout="ValidarEmail" type="email" class="form-control form-control-lg" :class="{campoInvalido:!EmailConfirmado, campoValido:EmailConfirmado && msg != ''}" id="Email" aria-describedby="emailHelp" placeholder="Seu email" required v-model="email">
                                <div class="validacao">
                                    <span v-if="msg != '' && !EmailConfirmado">
                                        <p class="invalido">
                                            <i id="IconeInvalido" class="fas fa-exclamation-circle"></i>
                                            {{msg}}
                                        </p>
                                    </span>
                                    <span v-if="msg != '' && EmailConfirmado">
                                        <p class="valido">
                                            <i id="IconeValido"   class="fas fa-check"></i>
                                            {{msg}}
                                        </p>
                                    </span>
                                </div>
                            </div>
                            <div class="col-12 col-md-6">
                                <input type="password" id="password" name="password" data-toggle="password" placeholder="Senha" v-model="password" class="form-control form-control-lg"  required>
                            </div>
                        </div>
                        <div class="row d-flex flex-md-row-reverse align-items-center">
                            <div class="col-12 col-md-5">
                                <button type="submit" class="btn btn-lg btn-primary" :disabled="!EmailConfirmado &&  msg != ''">Comece a investir</button>
                            </div>
                            <div class="col-12 col-md-7 text-center text-md-left">
                                <span class="font-low">{{ this.cdi }} do CDI</span>
                                <small>Retorno potencial no ano <i class="far fa-question-circle" data-toggle="tooltip" title="Considerando o retorno médio dos empréstimos em curso (CDI) até o mês de abril/2019."></i></small>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="row text-center text-md-left">
                <div class="col-12 col-md-6">
                    <h3>Por que investir na IOUU?</h3>
                    <p>Nossa plataforma conecta você com empresas qualificadas de uma forma rápida, simples e transparente, usando o melhor das tecnologias atuais. Garantimos retornos altos, superiores aos investimentos tradicionais como Poupança, CDB e Tesouro direto.</p>
                </div>
                <div class="col-12 col-md-6">
                    <h3>Cuidamos do seu investimento</h3>
                    <p>Realizamos uma avaliação de crédito rigorosa através do nosso motor de crédito de alta tecnologia, de modo que você empresta seu dinheiro para empresas com capacidade de pagamento, de acordo com nossas expectativas.</p>
                </div>
            </div>
            <hr class="tealish">
            <div class="row">
                <div class="col-12 text-center">
                    <h2>Investimentos em 3 passos</h2>
                </div>
                <div class="col-12 col-md-4 text-center text-md-left">
                    <span class="circle">
                        <strong>1</strong>
                    </span>
                    <h3>Tomador solicita empréstimo</h3>
                    <p>Nossa plataforma conecta você com empresas qualificadas de uma forma rápida, simples e transparente, usando o melhor das tecnologias atuais. Garantimos retornos altos, superiores aos investimentos tradicionais como Poupança, CDB e Tesouro direto.</p>
                </div>
                <div class="col-12 col-md-4 text-center text-md-left">
                    <span class="circle">
                        <strong>2</strong>
                    </span>
                    <h3>Voce consulta as rodadas disponíveis</h3>
                    <p>Acesse as oportunidades disponíveis na plataforma e confira o resultado completo de nossa análise de crédito, podendo escolher onde investir de acordo com seu perfil.</p>
                </div>
                <div class="col-12 col-md-4 text-center text-md-left">
                    <span class="circle">
                        <strong>3</strong>
                    </span>
                    <h3>Invista nas oportunidades Abertas</h3>
                    <p>Escolha a rodada de acordo com seu perfil de investidor e realize seu investimento. As parcelas são recebidas mensalmente na sua carteira virtual de acordo com a rentabilidade e prazo estabelecido.</p>
                </div>
            </div>
        </div>
        <div class="feature-margin pt-2 pt-md-4 pt-lg-5 pb-2 pb-md-4 pb-lg-5">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12">
                        <div class="jumbotron dusk text-center">
                            <h3>Porque realizar um investimento coletivo ou um investimento de impacto?</h3>
                            <hr class="tealish">
                            <p>Rápido. Simples. Bom para você e para o mundo</p>

                            <div class="row justify-content-center">
                                <div class="col-12 col-md-3 col-lg-2">
                                    <div class="icon icon-online"></div>
                                    <span>100% online</span>
                                </div>
                                <div class="col-12 col-md-3 col-lg-2">
                                    <div class="icon icon-rentabilidade"></div>
                                    <span>Alta rentabilidade</span>
                                </div>
                                <div class="col-12 col-md-3 col-lg-2">
                                    <div class="icon icon-taxas"></div>
                                    <span>Taxas mais justas</span>
                                </div>
                                <div class="col-12 col-md-3 col-lg-2">
                                    <div class="icon icon-transparencia"></div>
                                    <span>Transparência no processo</span>
                                </div>
                                <div class="col-12 col-md-3 col-lg-2">
                                    <div class="icon icon-acessivel"></div>
                                    <span>Acessível para todos</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="row justify-content-center data">
                <div class="col-12 text-center">
                    <h2>Rentabilidade dos empréstimos em curso</h2>
                </div>
                <div class="col-10">
                    <div class="row text-center">
                        <div class="col-12 col-md-4">
                            <span>384,07%</span>
                            <small>retorno médio (CDI)</small>
                            <p>Retorno médio dos empréstimos em curso (CDI).</p>
                        </div>
                        <div class="col-12 col-md-4">
                            <span>1,40%</span>
                            <small>crédito vencido</small>
                            <p>% de capital em atraso há mais de 60 dias e que está em processo de recuperação.</p>
                        </div>
                        <div class="col-12 col-md-4">
                            <span>356,70%</span>
                            <small>retorno médio real(CDI)</small>
                            <p>Retorno médio dos empréstimos em curso descontando a % de crédito vencido.</p>
                        </div>
                    </div>
                </div>
            </div>

            <hr class="tealish">

            <div class="row justify-content-center data">
                <div class="col-12 text-center">
                    <h2>Acumululada desde o lançamento</h2>
                </div>
                <div class="col-10">
                    <div class="row text-center">
                        <div class="col-12 col-md-4">
                            <span>24,54%</span>
                            <small>rentabilidade acomuludada bruta</small>
                            <p>Rentabilidade acumulada bruta dos empréstimos realizados desde o lançamento (12 meses).</p>
                        </div>
                        <div class="col-12 col-md-4">
                            <span>00,00%</span>
                            <small>débito podre</small>
                            <p>% de crédito perdido.</p>
                        </div>
                        <div class="col-12 col-md-4">
                            <span>24,54%</span>
                            <small>retorno acumulado ajustado</small>
                            <p>Rentabilidade acumulada bruta decontando a % de crédito perdido.</p>
                        </div>
                    </div>
                </div>
            </div>

            <hr class="tealish">

            <div class="row">
                <section class="col-12 depoimentos">
                    <div class="row">
                        <div class="col text-center">
                            <h2 class="main-title">Depoimentos</h2>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <div id="depoimentos" class="carousel slide" data-ride="carousel">
                                <ol class="carousel-indicators">
                                    <li data-target="#depoimentos" data-slide-to="0" class=""></li>
                                    <li data-target="#depoimentos" data-slide-to="1" class=""></li>
                                    <li data-target="#depoimentos" data-slide-to="2" class=""></li>
                                    <li data-target="#depoimentos" data-slide-to="3" class="active"></li>
                                    <li data-target="#depoimentos" data-slide-to="4" class=""></li>
                                    <li data-target="#depoimentos" data-slide-to="5" class=""></li>
                                </ol>
                                <div class="row justify-content-center">
                                    <div class="col-10 text-center">
                                        <div class="carousel-inner">
                                            <div class="carousel-item">
                                                <p>Realizado investimentos P2P com a IOUU e até o momento me sinto muito satisfeito. Acompanho diariamente minha carteira e tenho notado uma baixa inadimplência. Não tenho dúvidas que isto se deve ao trabalho
                                                    sério que realizam com as empresas tomadoras dos empréstimos. Sempre que precisei esclarecer minhas dúvidas sobre quaisquer assuntos fui prontamente atendido. Tenho conversado com amigos dispostos a investir
                                                    nesta modalidade e recomendo a IOUU.</p>
                                                <h3>Gilberto Domingues</h3> <small>São Paulo, São Paulo - Brasil</small>
                                            </div>
                                            <div class="carousel-item">
                                                <p>Gostaria de parabenizar pelo trabalho de vocês. A ideia da carteira virtual é sensacional e facilita muito para reinvestir. E o site de vocês é muito bonito e fácil de navegar. Já usei outras plataformas e
                                                    posso dizer que vocês são muito melhores.</p>
                                                <h3>Roberto Sávio</h3> <small>São José dos Campos, São Paulo - Brasil</small>
                                            </div>
                                            <div class="carousel-item">
                                                <p>Plataforma simples e completa, com as informações necessárias fáceis de achar, rendimento digno e, se não houver inadimplência, é perfeita.</p>
                                                <h3>Paolo dos Santos</h3> <small>Itapira, São Paulo - Brasil</small>
                                            </div>
                                            <div class="carousel-item active">
                                                <p>Tudo vem ocorrendo de forma clara e bem informada. Pra ser sincero, até extrapolei o que havia considerado como valor ideal para um início de relação com vocês, justamente por estar satisfeito com as
                                                    condições/estrutura/feedback oferecidos pela IOUU.</p>
                                                <h3>Jorge Araújo</h3> <small>Guarujá, São Paulo - Brasil</small>
                                            </div>
                                            <div class="carousel-item">
                                                <p>Acho que a IOUU montou uma plataforma bem estruturada, interativa e prática, além da qualidade das empresas investidas que trazem uma boa rentabilidade alternativa aos produtos bancários comuns.</p>
                                                <h3>Fernando de Marco</h3> <small>São José dos Campos, São Paulo - Brasil</small>
                                            </div>
                                            <div class="carousel-item">
                                                <p>Investir na IOUU foi uma grata surpresa, onde tem sido possível obter uma rentabilidade superior às aplicações tradicionais. Somado a isso, confio na empresa pois a IOUU demonstra um grande comprometimento com
                                                    os seus investidores.</p>
                                                <h3>Samuel Poeta</h3> <small>Montenegro, Rio Grande do Sul - Brasil</small>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            <hr class="tealish">

            <div class="row text-center text-md-left">
                <div class="col-12 text-center">
                    <h2>Conheça a IOUU</h2>
                </div>
                <div class="col-12 col-md-6">
                    <h3>O que é a IOUU?</h3>
                    <p>Conectamos empresas que procuram crédito e investidores com dinheiro para emprestar. Nossa plataforma é mais eficiente e transparente do que os empréstimos tradicionais e acreditamos que é um sistema melhor para todos.</p>
                </div>
                <div class="col-12 col-md-6">
                    <h3>O que significa investir?</h3>
                    <p>Você escolhe e investe nas melhores oportunidades da plataforma conforme seu perfil de investidor e, mês a mês, recebe pagamentos conforme a rentabilidade e prazo estimados.</p>
                </div>
            </div>

            <hr class="tealish">

            <div class="row questions">
                <div class="col-12 text-center">
                    <h2>Resposta para suas dúvidas</h2>
                </div>
                <div class="col-12 col-md-6">
                    <ul class="column-1">
                        <li><a href="#" data-toggle="modal" data-target="#id-001">Quais serviços a IOUU oferece para os investidores?</a></li>
                        <li><a href="#" data-toggle="modal" data-target="#id-002">Qual o valor mínimo de investimento?</a></li>
                        <li><a href="#" data-toggle="modal" data-target="#id-003">Quanto custa investir na IOUU?</a></li>
                    </ul>
                </div>
                <div class="col-12 col-md-6">
                    <ul class="column-2">
                        <li><a href="#" data-toggle="modal" data-target="#id-004">Qual o procedimento em caso de atraso da parcela mensal?</a></li>
                        <li><a href="#" data-toggle="modal" data-target="#id-005">Qual a garantia que receberei meu investimento de volta?</a></li>
                        <li><a href="#" data-toggle="modal" data-target="#id-006">A IOUU é um banco ou instituição financeira?</a></li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="feature-margin pt-2 pt-md-4 pt-lg-5 pb-2 pb-md-4 pb-lg-5">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12">
                        <div class="jumbotron background background-200852716 cta">
                            <div class="alpha"></div>
                            <div class="content">
                                <div class="row">
                                    <div class="col-12 col-md-6">
                                        <h3>Pronto para ganhar dinheiro e garantir o futuro?</h3>
                                        <a class="btn btn-light btn-lg" href="#cta" role="button">Comece a investir</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
   </div>
</template>

<style lang="scss" scoped>
    @import "../assets/styles/landing-page/vars";
    @import "../assets/styles/landing-page/mixins";
    @import "../assets/styles/landing-page/base";
    .campoInvalido{
        // medida necessaria para sobrepor o style padrao
        border: 1px solid red !important
    }
    .campoValido{
        // medida necessaria para sobrepor o style padrao
        border: 1px solid green !important
    }
    .invalido{
        color:red !important;
    }
    .valido{
        color:green !important;
    }

    .font-low {
        font-size: 2rem !important;
    }
</style>

<style lang="scss">
    .input-group-append {
		display:block!important;
		padding:0px;

		span {
			padding-top:0px;
			padding-bottom:0px;
		}

		i {
			font-size:16px;
			line-height: 46px;
		}
	}
</style>

<script>
// import ApiClient from '@/utils/api-client'
// import ArrayHelper from '@/utils/array-helper'
import PasswordField from '@/components/PasswordField'
import HubConsultaClient from '@/utils/hub-consulta-client.js'

export default {
    data() {
        return {
            cdi:'384,07%',
            name: '',
            email: '',
            password: '',
            enabled: false,
            visivel:false,
            EmailConfirmado:true,
            msg:''
        }
    },
    components: {
        PasswordField
    },
    metaInfo: {
        title: 'Seja um investidor IOUU'
    },
    methods:{
        validateName() {
            if(this.name[0] == " ") {
                this.name = "";
                return;
            }

            var splitText = this.name.split(' ');
            var upperCaseText = '';

            for(var i = 0; i < splitText.length; i++) {
                if(splitText[i] != "") {
                    if(i > 0)
                    upperCaseText += " ";

                upperCaseText += splitText[i][0].toUpperCase() + splitText[i].slice(1);
                }
                else if(i > 0)
                upperCaseText += " ";
            }

            this.name = upperCaseText;
        },
        ValidarEmail: function () {
            this.EmailConfirmado = true
            this.msg = ""
            //Chama API que faz a Pré Validação do Email para verificar se a ortografia esta correta
            if(this.email != "") {
                HubConsultaClient.PreValidacaoEmail(this.email)
                .then(resposta => {

                //Sintaxe do Email Inválida
                if(resposta.Msg == "Email Inválido") {
                    this.EmailConfirmado = false
                    this.msg = "Digite um email válido!"
                }

                //Sintaxe do Email Correta
                else {
                    //Chama API que verifica se este usuário já está cadastrado
                    HubConsultaClient.ExisteUsuario(this.email)
                    .then(resposta => {
                    if(resposta.Msg == "Existe") {
                        this.EmailConfirmado = false
                        this.msg = "Esse email já foi cadastrado no sistema!"
                    }
                    else {
                        //Chamar API que faz a validação do Email
                        HubConsultaClient.theCheckerPost(this.email)
                        .then(resposta => {

                            if(resposta == "Entregável") {
                                //Executa se o email for válido
                                this.EmailConfirmado = true
                                this.msg = "Email Validado com Sucesso!"
                            }

                            if(resposta == "Inválido") {
                                //Executa se o email for inválido
                                this.EmailConfirmado = false
                                this.msg = "Email Inválido!"
                            }

                        })
                        .catch(() => {
                            this.EmailConfirmado = true
                            this.msg = "Email Validado com Sucesso!"
                        });//Fim Validação TheChecker
                    }
                    })
                    .catch(() => {
                        this.EmailConfirmado = true
                        this.msg = "Email Validado com Sucesso!"
                    }); //Fim Existe Usuário
                }

                })
                .catch(() => {
                    this.EmailConfirmado = true
                    this.msg = "Email Validado com Sucesso!"
                });//Fim Validação Email
            }
        },
        signUp() {
            this.$store.dispatch('signup', {name: this.name, email: this.email, password: this.password})
            .then(() => {
                this.$router.push("/cadastro-concluido-com-sucesso");
            })
            .catch(error => {
                const errorMessages = error.response.data.errors.map(error => error.detail)
                alert(errorMessages)
            })

            // CADASTRA CONTATO EM ACTIVE CAMPAIN
            HubConsultaClient.CadastrarActive(this.email)

        },
        //tagueamento GA
        taggingGA() {
            this.$ga.page({
                page: '/landing-page/seja-um-investidor-iouu/ ',
                title: 'Seja um investidor IOUU',
            })
        },
    },
    async created() {
        if(this.$route.query.name)
        this.name = this.$route.query.name;

        if(this.$route.query.email)
        this.email = this.$route.query.email;

        if(this.$route.query.v)
        this.visivel = true

        //tagueamento GA
        await this.taggingGA();
    }
}
</script>



// WEBPACK FOOTER //
// src/views/LandingPageInvistaIouu.vue